import { render, staticRenderFns } from "./BreedingTable.vue?vue&type=template&id=37432933&scoped=true&"
import script from "./BreedingTable.vue?vue&type=script&lang=js&"
export * from "./BreedingTable.vue?vue&type=script&lang=js&"
import style0 from "./BreedingTable.vue?vue&type=style&index=0&id=37432933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37432933",
  null
  
)

export default component.exports